module.exports = __webpack_public_path__ + "static/media/ProfileImage.fdf7464e.jpg";